import { render } from "./CustomizeResourceTable.vue?vue&type=template&id=7eb09458"
import script from "./CustomizeResourceTable.vue?vue&type=script&lang=js"
export * from "./CustomizeResourceTable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CustomizeResourceTable.vue"]])

export default __exports__